import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

/**
 * DiagnosisService
 * Handles API calls related to the diagnosis catalog master list.
 */
@Injectable({
  providedIn: 'root'
})
export class DiagnosisService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  /**
   * Helper function to construct authentication headers.
   */
  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  /**
   * Fetch all diagnosis tags from the catalog.
   */
  getDiagnosis() {
    return this.http.get(
      this.apiUrl + '/diagnosis', this.getAuthHeaders()
    );
  }

  /**
   * Add a new diagnosis tag to the catalog.
   */
  addDiagnosis(payload: any) {
    return this.http.post(this.apiUrl + '/diagnosis', payload, this.getAuthHeaders());
  }

  /**
   * Update an existing diagnosis tag.
   */
  updateDiagnosis(payload: any) {
    return this.http.put(this.apiUrl + '/diagnosis/' + payload.id, payload, this.getAuthHeaders());
  }

  /**
   * Delete a diagnosis tag.
   */
  deleteDiagnosis(payload: any) {
    return this.http.put(this.apiUrl + '/diagnosis', payload, this.getAuthHeaders());
  }
}
